import { commitOptions, retryOptions, decodeBulkResult } from "./commitSeams";
import { api } from "@/lib/api/client";

export interface ZoomConnection {
  account_id: string;
  credential_generation: string;
  enabled: boolean;
  verified_at: string;
  revoked_at: string | null;
  updated_at?: string;
}

export interface ZoomHostBinding {
  host_binding_id: string;
  user_id: string;
  account_id: string;
  zoom_user_id: string;
  credential_generation: string;
  license_state: "licensed" | "unlicensed" | "unknown";
  verified_at: string;
  revoked_at: string | null;
}

export interface ZoomConnectionResponse {
  connection: ZoomConnection | null;
  observed_user?: {
    id: string;
    license_state: ZoomHostBinding["license_state"];
  };
}

export interface ZoomHostBindingResponse {
  host_binding: ZoomHostBinding | null;
}

const userPath = (userId: string) =>
  `/admin/zoom/host-bindings/${encodeURIComponent(userId)}`;

export interface RefreshVerification {
  zoom_user_id: string; connection_version: string; host_version: string; ids: string[];
}

export const zoomAdminApi = {
  refreshVerification: async (userId: string, body: RefreshVerification, key: string, retry = false) =>
    decodeBulkResult(await api.post(`${userPath(userId)}/refresh`, body, retry ? retryOptions(key) : commitOptions(key))),
  getConnection: () => api.get<ZoomConnectionResponse>("/admin/zoom/connection"),
  getHostBinding: (userId: string) =>
    api.get<ZoomHostBindingResponse>(userPath(userId)),
  refreshConnection: (zoomUserId: string) =>
    api.post<ZoomConnectionResponse>("/admin/zoom/connection/readback", {
      zoom_user_id: zoomUserId,
    }),
  refreshHostBinding: (userId: string, zoomUserId: string) =>
    api.post<ZoomHostBindingResponse>(`${userPath(userId)}/readback`, {
      zoom_user_id: zoomUserId,
    }),
};
